import React from "react";
import Icon from "../../elements/icon";
import "./style.scss";

const Filter = ({
  heading,
  resetText,
  selectedFilters,
  onResetAllFilter,
  onClearFilter,
  onFilterIconClick,
}) => {
  return (
    <div className="filter">
      <div className="filter__bar">
        <div className="filter__icon-heading" onClick={onFilterIconClick}>
          <div className="filter__icon">
            <Icon name="Filter" />
          </div>
          <span className="filter__heading">{heading}</span>
        </div>
        {selectedFilters.length > 0 && (
          <span className="filter__reset" onClick={() => onResetAllFilter()}>
            {resetText}
          </span>
        )}
      </div>
      <ul className="filter__selected-options-list">
        {selectedFilters.map((option, index) => (
          <li className="filter__selected-option" key={index}>
            <Icon name="Close" onClick={() => onClearFilter(index)}></Icon>
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
Filter.defaultProps = {
  selectedFilters: [],
};

export default Filter;
